export const getWaitingAmount = state => {
    const gains = getGains(state);
    if (!gains) return 0;
    return Object.keys(gains).reduce(
        (res, curr) =>
            gains[curr].waitingStateAmount ? res + gains[curr].waitingStateAmount : res,
        0
    );
};

export const getValidatedAmount = state => {
    const gains = getGains(state);
    if (!gains) return 0;
    return Object.keys(gains).reduce(
        (res, curr) => (gains[curr].validatedAmount ? res + gains[curr].validatedAmount : res),
        0
    );
};

export const getGains = state =>
    state.account.gains && state.account.gains.gains ? state.account.gains.gains : [];



// WEBPACK FOOTER //
// ./src/services/account/gains/selector.js